import React from 'react';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';

const NotFound = () => {

	const history = useHistory();

	const goDashboard = () => {
		history.push('/');
	}

	return (
		<div className="layout-topbar-blue pages-body flex flex-column" >
			<div className="layout-topbar shadow-4 p-3 flex justify-content-between flex-row align-items-center">
				<div className="layout-topbar-left ml-3 flex" >
					<div className="logo">
						<img src="assets/layout/images/logo2x.png" alt="" />
					</div>
				</div>
				<div className="topbar-right mr-3 flex">
					<Button type="button" onClick={goDashboard} label="DASHBOARD"
						className="p-button-rounded p-button-info font-Gerstner-ProgramRegular text-base font-semibold px-4 charcoal-color hover:bg-green-200" style={{ float: "right", letterSpacing: "1.44px", backgroundColor: "#9AAB89" }}></Button>
					</div>
			</div>

			<div className="align-self-center mt-auto mb-auto">
				<div className="pages-panel card shadow-4 flex flex-column" style={{border:'2px solid #9AAB89'}}>
					<div className="pages-header   px-3 py-1" style={{border:'2px solid #9AAB89', background:'white'}}>
						<h2 className='font-Gerstner-ProgramRegular' style={{color:'#9AAB89'}}>NOT FOUND</h2>
					</div>
					<div className="card mt-3 px-6">
						<img src="assets/layout/images/pages/404.png" alt="" />
					</div>
					<div className="pages-detail pb-6 font-Gerstner-ProgramRegular">Requested resource is not available.</div>
					<Button type="button" onClick={goDashboard} label="GO BACK TO DASHBOARD" className="p-button-text font-Gerstner-ProgramRegular"></Button>
				</div>
			</div>
		</div>
	)
}

export default NotFound;
